export const statsAllDateStart = "2024100100";